import BrandMark from "./BrandMark";

/** Horizontal lockup: symbol + TymLogr [| by Ryganlab]. */
export default function Lockup({
  symbolSize = 34,
  wordmarkClassName = "text-2xl font-bold tracking-tight",
  showEndorsement = true,
  variant = "brass",
  className = "",
  inkClassName = "text-[var(--brand-midnight)] dark:text-[var(--brand-midnight)]",
  steelClassName = "text-[var(--brand-steel)]",
}) {
  const narrow = symbolSize < 28;
  // Wider gap as the mark grows so the wordmark sits clear of the symbol (not cramped in the corner).
  const markGap = symbolSize >= 26 ? "gap-3" : "gap-2.5";
  return (
    <div className={`flex items-center ${markGap} ${className}`} data-testid="brand-lockup">
      <BrandMark size={symbolSize} variant={variant} className="shrink-0" />
      <div className="flex items-center gap-2 min-w-0">
        <span className={`${wordmarkClassName} ${inkClassName} font-heading truncate`}>TymLogr</span>
        {showEndorsement && !narrow && (
          <>
            <span className={`hidden sm:inline w-px h-5 bg-[var(--brand-hairline)]`} aria-hidden />
            <span className={`hidden sm:inline text-sm ${steelClassName} whitespace-nowrap`}>
              by Ryganlab
            </span>
          </>
        )}
      </div>
    </div>
  );
}
